<template>
  <div class="columns is-multiline mgt-20px">
    <div class="column is-12">
      <div class="card contactEdition">
        <div class="header-card">
          <p>
            {{ title}}
          </p>
        </div>
        <div class="card-content">
          <b-field :label="label" v-if="!isDetail">
            <b-input type="textarea" v-model="texteValue">
            </b-input>
          </b-field>
          <b-field v-else
            custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ texteValue }}
            </span>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
    },
    label: {
      type: String,
      required: false,
    },
    value: {
      type: [String, null],
      required: false,
      default: '',
    },
    isDetail: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    texteValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
};
</script>

<style>

</style>
